import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

 
interface IProps {
    currentOperator?: any,
    customOperators?: any,
    operatorClick?: any
}
const OperatorDropdown = ({currentOperator,customOperators,operatorClick}: IProps) => {
return(
<DropDownList
          style={{ marginBottom: '10px' }}
          textField="text"
          dataItemKey="operator"
          popupSettings={{
            width: '',
          }}
          value={currentOperator}
          data={customOperators}
          onChange={operatorClick}
        />
    )
}
 
export default OperatorDropdown;